export const Options = {
    Location: [
        { text: "Berlin", value:"Berlin"},
        { text: "Chemnitz", value:"Chemnitz"},
        { text: "Düsseldorf", value:"Düsseldorf"},
        { text: "Frankfurt", value:"Frankfurt"},
        { text: "Hamburg", value:"Hamburg"},
        { text: "Köln", value:"Köln"},
        { text: "München", value:"München"},
        { text: "Stuttgart", value:"Stuttgart"},
    ],
    Salutation: [
        { text: "Herr" ,value:"Herr"},
        { text: "Frau",value:"Frau" },
        { text: "Neutral",value:"Neutral" },
    ],
    OtherPositions: [
        {text:"Ja",value:"Ja"},
        {text:"Nein",value:"Nein"},
    ]
}
